import type { Calibration } from '@studio/models/control/calibration';
import { Status } from '@studio/models/control/calibration';
import type { T_Maybe } from '@tryiris-ai/js-types';

/** Calibration language constants. */
export const Lang = {
  /**
   * Calibration formatter.
   *
   * @param calibration - Calibration data.
   * @returns Status string.
   */
  calibration(calibration: T_Maybe<Calibration>): string {
    const { progress, status } = calibration ?? {};

    if (status === Status.CALIBRATION_STATE_RUNNING) {
      return `Calibrating${progress ? ` (${progress}%)` : '...'}`;
    }

    if (status === Status.CALIBRATION_STATE_OK || status === Status.CALIBRATION_STATE_SUCCESS) {
      return 'Calibrated';
    }

    if (status === Status.CALIBRATION_STATE_FAIL) {
      return 'Calibration failed';
    }

    return 'Unknown';
  }
};
